export default __webpack_public_path__ + "static/media/Subham Jewellery Eng.14533d2c.jpg";